<!-- 商品规格详情 -->
<template>
    <div class="page-form">
        <PageBack :title="title" />
        <div class="detail-wrap">
            <el-form :model="searchForm" ref="searchForm"  :inline="true"> 
            <!-- <el-form-item label="名称" prop="specName">
                <el-input style="width: 200px;" v-model="searchForm.specName"></el-input>
            </el-form-item>    -->
            <el-form-item>
                <!-- <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button> -->
                <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
                <el-button type="success" @click="handleAdd">添加规格</el-button>
            </el-form-item>          
        </el-form>
        <el-table :data="tableData" border>
        <el-table-column type="expand">
            <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="名称">
                    <span>{{ props.row.specName }}</span>
                </el-form-item>
                <el-form-item label="材质">
                    <span>{{ props.row.material }}</span>
                </el-form-item>
                <el-form-item label="尺寸">
                    <span>{{ props.row.size }}</span>
                </el-form-item>
                <el-form-item label="重量">
                    <span>{{ props.row.weight }}</span>
                </el-form-item>
                <el-form-item label="颜色">
                    <span>{{ props.row.colour }}</span>
                </el-form-item>
                <el-form-item label="规格详情">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                <el-form-item label="规格图片">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                <el-form-item label="详情图片">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                </el-form>
            </template>
        </el-table-column>
        <el-table-column property="specName" label="规格名称" ></el-table-column>
        <el-table-column property="productPrice" label="价格(元)" width="100"></el-table-column>
        <el-table-column property="productQuality" label="库存数量"></el-table-column>
        <el-table-column property="date" label="更新日期"></el-table-column>
        <el-table-column  fixed="right" label="操作">
            <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="text" 
                    size="small">编辑</el-button>
                <el-button @click="handleDelete(scope.row)" type="text" 
                    size="small">刪除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
    </div>
    <AddSpec :title="goodsSpecDialogTitle" 
            v-if="isShowGoodsSpec"
            :formData="goodsSpecForm" 
            @close="closeDialog"
            ref="childComponentSpecRef"
            @confirm="handleConfirmSpec"></AddSpec>

</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import AddSpec from './components/addSpec'
export default {
    components:{
        PageBack,
        pagination,
        AddSpec
    },
    data() {
        return {
            isShowGoodsSpec: false,
            goodsSpecDialogTitle: '',
            goodsSpecForm: { },
            dialogVisible: true,
            searchForm:{
                specName: '',
                certType: '',
                status: ''
            },
            tableData: [],
            statusOption: [
                {value:'', label:'全部'},
                {value:'1', label:'上架'},
                {value:'2', label: '下架'},
            ],
            total: 0,
            queryParams:{
                page: 1,
                pagesize: 10
            },
            productId: '',
            typeOption: [
                {value:'1', label:'普通库存'},
                {value:'2', label:'预售模式'},
                {value:'3', label:'其它'},
            ],
        }       
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {
        // 商品标识
        // this.getType()
        this.productId = this.$route.query.id
    },
    mounted() { 
        this.initData()
        // console.log(this.tableData)
    },
    methods: {
        getType(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 112,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })  
                    console.log(this.typeOption)                 
                }
            })
        }, 
        initData(){
            let params = {
                opcode: this.$code.GoodsSpec,
                v_goods_serial: this.productId,
                i_norms_serial: 0,
                pagesize: this.queryParams.pagesize,
                size: this.queryParams.size,
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                  
                    let arr = res.Data.DataTable                    
                    if(arr.length > 0){                        
                        this.tableData = arr.map(item=>{
                            let  mainImageUrl = item['商品规格图片']
                            let  detailImageUrl =  item['商品规格图片1']
                            let  mode = this.typeOption.filter(i => i.label === item['库存策略'])
                            return{
                                index: item['序号'],
                                specName: item['商品规格标题'],
                                specSubName: item['商品规格副标题'],
                                productId: item['商品标识'],
                                productSpecId: item['商品规格标识'],
                                isDefault: item['是否置顶'],
                                productPrice: item['价格'],
                                productQuality: item['数量'],
                                size: item['尺寸'],
                                colour: item['颜色'],
                                material: item['材质'], 
                                weight: item['重量'],   
                                productMode:  mode[0].value,
                                limitQuality: item['限购设置'],
                                des: item['商品规格详情'], 
                                date: this.$help.formatDate(item['更新日期']),                               
                                mainImageUrl: mainImageUrl,
                                detailImageUrl:detailImageUrl,                                
                            }
                        })                        
                    }else{
                        this.tableData = []                 
                    }
                }
            })
        },
        handleUpdate(row){            
            this.isShowGoodsSpec = true
            this.goodsSpecDialogTitle = '更新规格'
            this.goodsSpecForm = {...row}
            // this.resetForm()
            // this.$emit('close');
        },
        handleDelete(row){
            this.$confirm('确定删除商品规格吗？','警告',).then(res=>{
               this.confirmDelete(row)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmDelete(row){
            let params = {
                opcode: this.$code.GooodsRemoveSpec,
                v_goods_serial: row.productId,
                i_norms_serial: row.productSpecId
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('删除规格成功')   
                    this.initData()
                    this.$emit('confirm',row.productId)                           
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        closeDialog() {
            this.isShowGoodsSpec = false
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        },
        handleConfirmSpec(){
            this.initData()
        },
        handleAdd(){
            this.isShowGoodsSpec = true
            this.goodsSpecDialogTitle = '添加规格'
            this.goodsSpecForm = {
                productId: this.productId
            }
        },
        searchQuery(){

        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.demo-table-expand {
    font-size: 0;
    margin-left: 20px;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }
</style>


// WEBPACK FOOTER //
// src/views/product/specDetail.vue